var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.706,
    height: 14.819,
    viewBox: "1667.219 505.798 26.706 14.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1680.57 508.802a4.413 4.413 0 1 1 .031 8.827 4.413 4.413 0 0 1-.031-8.827Zm-13.123 3.803a23.19 23.19 0 0 1 2.242-2.364c3.123-2.842 6.674-4.361 10.35-4.44 3.677-.078 7.408 1.287 10.942 4.199.969.803 1.88 1.675 2.725 2.607a.87.87 0 0 1 .054 1.087 17.358 17.358 0 0 1-3.342 3.566 15.11 15.11 0 0 1-9.416 3.357 16.515 16.515 0 0 1-9.618-3.12 19.416 19.416 0 0 1-3.979-3.777.856.856 0 0 1 .042-1.115Zm3.396-1.086a21.6 21.6 0 0 0-1.65 1.67 17.571 17.571 0 0 0 3.178 2.906 14.833 14.833 0 0 0 8.625 2.81 13.405 13.405 0 0 0 8.346-2.982c.975-.781 1.85-1.679 2.608-2.672a24 24 0 0 0-2.065-1.926c-3.205-2.642-6.569-3.876-9.822-3.81-3.253.068-6.406 1.433-9.22 3.995Zm8.625-1.693a1.71 1.71 0 1 1 0 3.42 1.71 1.71 0 0 1 0-3.42Z",
    fill: "#707070",
    fillRule: "evenodd",
    "data-name": "view-icon (1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.2f9f1232afbd3f7d696bd8929d19120b.svg";
export { ForwardRef as ReactComponent };